import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navLinks = [
    { label: "Rólunk", href: "#bemutatkozas" },
    { label: "Szolgáltatások", href: "#szolgaltatasok" },
    { label: "Kapcsolat", href: "#kapcsolat" },
];

export const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);
    const location = useLocation();
    const isLegal = location.pathname !== "/";
    const showSolid = scrolled || isLegal || open;

    const resolveHref = (href) => (isLegal && href.startsWith("#") ? `/${href}` : href);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 left-0 right-0 z-50 ${
                showSolid
                    ? "bg-white/90 backdrop-blur-xl border-b border-black/10"
                    : "bg-transparent border-b border-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-16 sm:h-20 flex items-center justify-between">
                <Link
                    to="/"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    data-testid="nav-logo"
                    className="flex items-center"
                    aria-label="Stabilor főoldal"
                >
                    <img
                        src="/images/stabilor-logo.png"
                        alt="Stabilor"
                        width="180"
                        height="60"
                        className={`h-10 sm:h-12 w-auto ${
                            showSolid ? "[filter:brightness(0)]" : ""
                        }`}
                    />
                </Link>

                <nav className="hidden lg:flex items-center gap-8">
                    {navLinks.map((l) => (
                        <a
                            key={l.href}
                            href={resolveHref(l.href)}
                            data-testid={`nav-${l.href.replace("#", "")}`}
                            className={`link-underline text-sm font-medium transition-colors duration-300 ${
                                showSolid
                                    ? "text-[#0A0A0A] hover:text-[#0D7A73]"
                                    : "text-white/90 hover:text-white"
                            }`}
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="hidden lg:flex items-center gap-4">
                    <a
                        href={resolveHref("#kapcsolat")}
                        data-testid="nav-cta"
                        className="bg-[#0D7A73] text-white text-sm font-bold px-5 py-2.5 hover:bg-[#0A5E58] transition-colors"
                    >
                        Ajánlatot kérek
                    </a>
                </div>

                <button
                    onClick={() => setOpen((v) => !v)}
                    data-testid="nav-mobile-toggle"
                    aria-label="Menü"
                    className={`lg:hidden p-2 ${
                        showSolid ? "text-[#0A0A0A]" : "text-white"
                    }`}
                >
                    {open ? <X /> : <Menu />}
                </button>
            </div>

            {open && (
                <div
                    data-testid="nav-mobile-menu"
                    className="lg:hidden bg-white border-t border-black/10"
                >
                    <div className="px-6 py-6 flex flex-col gap-4">
                        {navLinks.map((l) => (
                            <a
                                key={l.href}
                                href={resolveHref(l.href)}
                                onClick={() => setOpen(false)}
                                data-testid={`nav-mobile-${l.href.replace("#", "")}`}
                                className="text-[#0A0A0A] text-base font-medium border-b border-black/5 pb-3"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href={resolveHref("#kapcsolat")}
                            onClick={() => setOpen(false)}
                            data-testid="nav-mobile-cta"
                            className="bg-[#0D7A73] text-white text-center font-bold py-3 mt-2"
                        >
                            Ajánlatot kérek
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};
